import { KeyLabel, MOD } from './KeyLabel';
export const KeyLabelGreek: KeyLabel[] = [
  {
    code: 4,
    label: 'Α',
  },
  {
    code: 5,
    label: 'Β',
  },
  {
    code: 6,
    label: 'Ψ',
    meta: [
      {
        label: '©',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 7,
    label: 'Δ',
  },
  {
    code: 8,
    label: 'Ε',
    meta: [
      {
        label: '€',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 9,
    label: 'Φ',
  },
  {
    code: 10,
    label: 'Γ',
  },
  {
    code: 11,
    label: 'Η',
  },
  {
    code: 12,
    label: 'Ι',
  },
  {
    code: 13,
    label: 'Ξ',
  },
  {
    code: 14,
    label: 'Κ',
  },
  {
    code: 15,
    label: 'Λ',
  },
  {
    code: 16,
    label: 'Μ',
  },
  {
    code: 17,
    label: 'Ν',
  },
  {
    code: 18,
    label: 'Ο',
  },
  {
    code: 19,
    label: 'Π',
  },
  {
    code: 20,
    label: ';',
    meta: [
      {
        label: ':',
        modifiers: MOD.SFT,
      },
      {
        label: ':',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 21,
    label: 'Ρ',
    meta: [
      {
        label: '®',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 22,
    label: 'Σ',
  },
  {
    code: 23,
    label: 'Τ',
  },
  {
    code: 24,
    label: 'Θ',
  },
  {
    code: 25,
    label: 'Ω',
  },
  {
    code: 26,
    label: 'ς',
    meta: [
      {
        label: '΅ (dead)',
        modifiers: MOD.SFT,
      },
      {
        label: '΅ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 27,
    label: 'Χ',
  },
  {
    code: 28,
    label: 'Υ',
    meta: [
      {
        label: '¥',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 29,
    label: 'Ζ',
  },
  {
    code: 30,
    label: '1',
    meta: [
      {
        label: '!',
        modifiers: MOD.SFT,
      },
      {
        label: '!',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 31,
    label: '2',
    meta: [
      {
        label: '@',
        modifiers: MOD.SFT,
      },
      {
        label: '@',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '²',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 32,
    label: '3',
    meta: [
      {
        label: '#',
        modifiers: MOD.SFT,
      },
      {
        label: '#',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '³',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 33,
    label: '4',
    meta: [
      {
        label: '$',
        modifiers: MOD.SFT,
      },
      {
        label: '$',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '£',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 34,
    label: '5',
    meta: [
      {
        label: '%',
        modifiers: MOD.SFT,
      },
      {
        label: '%',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '§',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 35,
    label: '6',
    meta: [
      {
        label: '^',
        modifiers: MOD.SFT,
      },
      {
        label: '^',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¶',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 36,
    label: '7',
    meta: [
      {
        label: '&',
        modifiers: MOD.SFT,
      },
      {
        label: '&',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 37,
    label: '8',
    meta: [
      {
        label: '*',
        modifiers: MOD.SFT,
      },
      {
        label: '*',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¤',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 38,
    label: '9',
    meta: [
      {
        label: '(',
        modifiers: MOD.SFT,
      },
      {
        label: '(',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¦',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 39,
    label: '0',
    meta: [
      {
        label: ')',
        modifiers: MOD.SFT,
      },
      {
        label: ')',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '°',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 45,
    label: '-',
    meta: [
      {
        label: '_',
        modifiers: MOD.SFT,
      },
      {
        label: '_',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '±',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 46,
    label: '=',
    meta: [
      {
        label: '+',
        modifiers: MOD.SFT,
      },
      {
        label: '+',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '½',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 47,
    label: '[',
    meta: [
      {
        label: '{',
        modifiers: MOD.SFT,
      },
      {
        label: '{',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '«',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 48,
    label: ']',
    meta: [
      {
        label: '}',
        modifiers: MOD.SFT,
      },
      {
        label: '}',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '»',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 50,
    label: '(backslash)',
    meta: [
      {
        label: '|',
        modifiers: MOD.SFT,
      },
      {
        label: '|',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¬',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 51,
    label: '΄ (dead)',
    meta: [
      {
        label: '¨ (dead)',
        modifiers: MOD.SFT,
      },
      {
        label: '¨ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 52,
    label: "'",
    meta: [
      {
        label: '"',
        modifiers: MOD.SFT,
      },
      {
        label: '"',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 53,
    label: '`',
    meta: [
      {
        label: '~',
        modifiers: MOD.SFT,
      },
      {
        label: '~',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 54,
    label: ',',
    meta: [
      {
        label: '<',
        modifiers: MOD.SFT,
      },
      {
        label: '<',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 55,
    label: '.',
    meta: [
      {
        label: '>',
        modifiers: MOD.SFT,
      },
      {
        label: '>',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 56,
    label: '/',
    meta: [
      {
        label: '?',
        modifiers: MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 532,
    label: ':',
  },
  {
    code: 538,
    label: '΅ (dead)',
  },
  {
    code: 542,
    label: '!',
  },
  {
    code: 543,
    label: '@',
  },
  {
    code: 544,
    label: '#',
  },
  {
    code: 545,
    label: '$',
  },
  {
    code: 546,
    label: '%',
  },
  {
    code: 547,
    label: '^',
  },
  {
    code: 548,
    label: '&',
  },
  {
    code: 549,
    label: '*',
  },
  {
    code: 550,
    label: '(',
  },
  {
    code: 551,
    label: ')',
  },
  {
    code: 557,
    label: '_',
  },
  {
    code: 558,
    label: '+',
  },
  {
    code: 559,
    label: '{',
  },
  {
    code: 560,
    label: '}',
  },
  {
    code: 562,
    label: '|',
  },
  {
    code: 563,
    label: '¨ (dead)',
  },
  {
    code: 564,
    label: '"',
  },
  {
    code: 565,
    label: '~',
  },
  {
    code: 566,
    label: '<',
  },
  {
    code: 567,
    label: '>',
  },
  {
    code: 568,
    label: '?',
  },
  {
    code: 4628,
    label: ':',
  },
  {
    code: 4634,
    label: '΅ (dead)',
  },
  {
    code: 4638,
    label: '!',
  },
  {
    code: 4639,
    label: '@',
  },
  {
    code: 4640,
    label: '#',
  },
  {
    code: 4641,
    label: '$',
  },
  {
    code: 4642,
    label: '%',
  },
  {
    code: 4643,
    label: '^',
  },
  {
    code: 4644,
    label: '&',
  },
  {
    code: 4645,
    label: '*',
  },
  {
    code: 4646,
    label: '(',
  },
  {
    code: 4647,
    label: ')',
  },
  {
    code: 4653,
    label: '_',
  },
  {
    code: 4654,
    label: '+',
  },
  {
    code: 4655,
    label: '{',
  },
  {
    code: 4656,
    label: '}',
  },
  {
    code: 4658,
    label: '|',
  },
  {
    code: 4659,
    label: '¨ (dead)',
  },
  {
    code: 4660,
    label: '"',
  },
  {
    code: 4661,
    label: '~',
  },
  {
    code: 4662,
    label: '<',
  },
  {
    code: 4663,
    label: '>',
  },
  {
    code: 4664,
    label: '?',
  },
  {
    code: 5126,
    label: '©',
  },
  {
    code: 5128,
    label: '€',
  },
  {
    code: 5141,
    label: '®',
  },
  {
    code: 5148,
    label: '¥',
  },
  {
    code: 5151,
    label: '²',
  },
  {
    code: 5152,
    label: '³',
  },
  {
    code: 5153,
    label: '£',
  },
  {
    code: 5154,
    label: '§',
  },
  {
    code: 5155,
    label: '¶',
  },
  {
    code: 5157,
    label: '¤',
  },
  {
    code: 5158,
    label: '¦',
  },
  {
    code: 5159,
    label: '°',
  },
  {
    code: 5165,
    label: '±',
  },
  {
    code: 5166,
    label: '½',
  },
  {
    code: 5167,
    label: '«',
  },
  {
    code: 5168,
    label: '»',
  },
  {
    code: 5170,
    label: '¬',
  },
];
